import SpinnerIcon from "./Icons/SpinnerIcon";
import { Menu, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { usePopper } from "hooks/usePopper";
import { ChevronDownIcon } from "@heroicons/react/outline";

const ESignatureManualDropDown = ({
  handleEsignature,
  handleManualSigning,
  esignatureIsSelected,
  isSubmitting,
}) => {
  const [trigger, container] = usePopper({
    placement: "bottom-end",
    strategy: "fixed",
    modifiers: [{ name: "offset", options: { offset: [0, 10] } }],
  });
  return (
    <div className={`flex flex-row gap-0.5`}>
      <button
        type="submit"
        onClick={handleEsignature}
        className={`flex px-2 py-2 button button-hover button-disabled button-outline button-focus
                 hover:bg-green-600 hover:shadow-lg text-white bg-sflPrimary rounded-l-md rounded-r-none
                              `}
      >
        {esignatureIsSelected ? (
          isSubmitting ? (
            <>
              <SpinnerIcon />
              Loading E Signing...
            </>
          ) : (
            <>
              <div className="ml-1.5 flex items-center">E Signature</div>
            </>
          )
        ) : isSubmitting ? (
          <>
            <SpinnerIcon />
            Loading Manual Signing...
          </>
        ) : (
          <>
            <div className="ml-1.5 flex items-center">E Signature</div>
          </>
        )}
      </button>
      <Menu as="div">
        <Menu.Button
          ref={trigger}
          className={`flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus
                          bg-sflPrimary hover:bg-green-600 hover:shadow-lg  rounded-l-none rounded-r-md
                                `}
        >
          <span className="sr-only">Open options</span>
          <ChevronDownIcon className="h-5 w-5" aria-hidden="true" />
        </Menu.Button>
        <div ref={container} className="z-50">
          <Transition
            as={Fragment}
            enter="transition ease-out duration-100"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <Menu.Items>
              <div className="py-1">
                <Menu.Item>
                  {({ active }) => (
                    <button
                      type="submit"
                      className={`flex px-2 py-2 text-white button button-hover button-disabled button-outline button-focus
                                                  hover:bg-green-600 hover:shadow-lg rounded bg-sflPrimary
                                            `}
                      onClick={handleManualSigning}
                    >
                      {isSubmitting ? (
                        <>
                          <SpinnerIcon />
                          Saving...
                        </>
                      ) : (
                        <>
                          <div className="ml-1.5 flex items-center">
                            Manual Signing
                          </div>
                        </>
                      )}
                    </button>
                  )}
                </Menu.Item>
              </div>
            </Menu.Items>
          </Transition>
        </div>
      </Menu>
    </div>
  );
};

export default ESignatureManualDropDown;
